export default function restrictInputNumber(ele){
  if ($(ele).data('decimal') != null) {
      var decimal = parseInt($(ele).data('decimal')) || 0;
      var val = $(ele).val();

      if (decimal > 0) {
          var splitVal = val.split('.');
          if (splitVal.length == 2 && splitVal[1].length > decimal) {
              // user entered invalid input
              return splitVal[0] + '.' + splitVal[1].substr(0, decimal);
          }
      } else if (decimal == 0) {
          // do not allow decimal place
          var splitVal = val.split('.');
          if (splitVal.length > 1) {
              // user entered invalid input
              return splitVal[0];
          }
      }

      return val;
  }
}
